import React from 'react';
import { bool } from 'prop-types';
import UnavailableBadge from './UnavailbleBadge';
import OnlineBadge from './OnlineBadge';

import './style.scss';

const Status = ({ isOnline = false, isUnavailable = false }) => {
    if (!isOnline && !isUnavailable) {
        return null;
    }

    let StatusBadge = null;

    if (isUnavailable) {
        StatusBadge = UnavailableBadge;
    } else if (isOnline) {
        StatusBadge = OnlineBadge;
    }

    return (
        <div className="status">
            <StatusBadge />
        </div>
    );
};

Status.propTypes = {
    isOnline: bool,
    isUnavailable: bool,
};

export default Status;
